import { Component, inject } from '@angular/core';
import { Router } from '@angular/router';
import { CookieService } from 'ngx-unificator/services';
import { AsyncPipe } from '@angular/common';
import { EpmCountryRestrictionService } from '../../../../../services/epm-country-restriction.service';
import { TranslatePipe } from '../../../../translation/translate.pipe';
import { BtnComponent } from '../../../../components/btn/btn.component';

@Component({
    selector: 'app-cookie-message-content',
    templateUrl: './cookie-message-content.component.html',
    styleUrls: ['./cookie-message-content.component.scss'],
    imports: [AsyncPipe, TranslatePipe, BtnComponent]
})
export class CookieMessageContentComponent {
  private _router = inject(Router);
  private _cookies = inject(CookieService);
  epm = inject(EpmCountryRestrictionService);


  goToPolicy() {
    this._router.navigateByUrl(`/cookie-policy`).then();
  }

  cookiesAccepted() {
    this._cookies.set('isCookiesAccepted', 'true', 999, '/');
  }
}
